<div mat-dialog-title class="modal-header">{{ data ? 'Edit' : 'Add' }} Custom Field</div>

<mat-dialog-content>
  <form class="w-100 display-flex flex-column grid-gap-16" [formGroup]="form">
    <div class="w-100 display-flex grid-gap-16 align-items-center">
      <app-input
        formControlName="name"
        class="flex-1"
        [attrPlaceholder]="'Enter custom field name'"
        [attrLabel]="'Name'"></app-input>

      <app-radio-button-dropdown
        formControlName="appliesTo"
        class="flex-1"
        [items]="appliesToOptions"
        [label]="'Applies To'"
        [allowClear]="false"
        [allowSearch]="false"
        [multiSelect]="true"
        attrAppendTo="body"></app-radio-button-dropdown>
    </div>

    <div class="w-100 display-flex flex-column">
      <span class="label-access-type">Access type</span>
      <div class="w-100 display-flex grid-gap-16 align-items-center">
        <app-radio-button-dropdown
          formControlName="rolesEdit"
          class="flex-1"
          [items]="roles$ | async"
          [label]="'Edit'"
          [labelCss]="'label-standard-font-size'"
          [attrPlaceholder]="'Select roles'"
          [itemPlaceholder]="'role'"
          [isLabelInside]="true"
          [allowClear]="true"
          [allowSearch]="(roles$ | async)?.length > 7"
          [multiSelect]="true"
          [allowSelectAll]="true"
          attrAppendTo="body"></app-radio-button-dropdown>

        <app-radio-button-dropdown
          formControlName="rolesView"
          class="flex-1"
          [items]="roles$ | async"
          [label]="'View'"
          [labelCss]="'label-standard-font-size'"
          [attrPlaceholder]="'Select roles'"
          [itemPlaceholder]="'role'"
          [isLabelInside]="true"
          [allowClear]="true"
          [allowSearch]="(roles$ | async)?.length > 7"
          [multiSelect]="true"
          [allowSelectAll]="true"
          attrAppendTo="body"></app-radio-button-dropdown>
      </div>
    </div>

    <div class="w-100 display-flex flex-column align-items-end">
      <div class="w-100 display-flex grid-gap-16 align-items-end">
        <app-radio-button-dropdown
          formControlName="customFieldType"
          class="flex-1"
          [items]="fieldTypeOptions"
          [label]="'Field Type'"
          [allowClear]="false"
          [allowSearch]="false"
          [attrDisable]="form.value.id"
          attrAppendTo="body"></app-radio-button-dropdown>

        <app-radio-button-dropdown
          *ngIf="form.value.customFieldType === CustomFieldType.Boolean"
          class="flex-1"
          formControlName="defaultValueBool"
          [items]="yesNoOptions"
          [label]="'Default Value'"
          [allowClear]="true"
          [allowSearch]="false"
          [attrPlaceholder]="'Select default value'"
          attrAppendTo="body"></app-radio-button-dropdown>

        <app-input
          *ngIf="form.value.customFieldType === CustomFieldType.Integer"
          class="flex-1"
          formControlName="defaultValueInt"
          [attrLabel]="'Default Value'"
          [attrPlaceholder]="'Enter default integer'"
          [attrMask]="'separator.0'"></app-input>

        <app-input
          *ngIf="form.value.customFieldType === CustomFieldType.Decimal"
          class="flex-1"
          formControlName="defaultValueNumber"
          [attrLabel]="'Default Value'"
          [attrPlaceholder]="'Enter default number'"
          [attrMask]="'separator.2'"></app-input>

        <app-input
          *ngIf="form.value.customFieldType === CustomFieldType.Amount"
          class="flex-1"
          formControlName="defaultValueMoney"
          [useCurrencyFormatter]="true"
          [attrLabel]="'Default Value'"
          [attrPlaceholder]="'Enter amount'"></app-input>

        <app-user-select-dropdown
          *ngIf="form.value.customFieldType === CustomFieldType.User"
          class="flex-1"
          formControlName="defaultValueUserId"
          [users]="users$ | async"
          [allowClear]="true"
          [allowSearch]="true"
          [attrPlaceholder]="'Select user'"
          [label]="'Default User'"
          [containerCss]="'display-flex flex-column'"
          attrAppendTo="body"></app-user-select-dropdown>

        <app-date-dropdown
          *ngIf="form.value.customFieldType === CustomFieldType.Date"
          class="flex-1"
          [isFullWidth]="true"
          formControlName="defaultValueDate"
          [label]="'Default Date'"
          [labelCss]="'nowrap pre-label'"
          [containerCss]="'display-flex flex-column'"
          [clearable]="true"
          [attrPlaceholder]="'Date'"></app-date-dropdown>

        <app-radio-button-dropdown
          *ngIf="form.value.customFieldType === CustomFieldType.DropDown"
          class="flex-1"
          formControlName="defaultValueDropDown"
          [items]="dropDownOptionsList"
          [label]="'Default Value'"
          [allowClear]="true"
          [allowSearch]="false"
          [allowAddNew]="true"
          [addNewAtTop]="true"
          [groupLabelBold]="true"
          [addNewLabel]="'Edit dropdown items'"
          [attrPlaceholder]="'Select default value'"
          (addNewClicked)="openDropdownOptionsEditor(dropDownOptions.controls)"
          [customValueTemplate]="customValueTemplate"
          [customListItemTemplate]="customListItemTemplate"
          attrAppendTo="body"></app-radio-button-dropdown>
      </div>

      <div class="flex-1">
        <app-input-error
          *ngIf="form.get('defaultValueInt')?.touched"
          [errors]="form.get('defaultValueInt')?.errors"
          [visible]="true"></app-input-error>
        <app-input-error
          *ngIf="form.get('defaultValueNumber')?.touched"
          [errors]="form.get('defaultValueNumber')?.errors"
          [visible]="true"></app-input-error>
      </div>
    </div>

    <!-- DateTime -->
    <div
      *ngIf="form.value.customFieldType === CustomFieldType.DateTime"
      class="w-100 display-flex grid-gap-16 align-items-end">
      <app-date-dropdown
        formControlName="defaultValueDate"
        class="flex-1"
        [isFullWidth]="true"
        [label]="'Default Date'"
        [containerCss]="'display-flex flex-column'"
        [clearable]="true"
        [attrPlaceholder]="'Date'"></app-date-dropdown>

      <app-radio-button-dropdown
        formControlName="defaultValueTime"
        class="flex-1"
        [allowClear]="true"
        [label]="'Default Time'"
        [allowSearch]="false"
        [autoSortList]="false"
        [items]="dateTimes"
        [attrPlaceholder]="'Time'"
        attrAppendTo="body"></app-radio-button-dropdown>
    </div>

    <app-input-area
      *ngIf="form.value.customFieldType === CustomFieldType.Text"
      formControlName="defaultValueText"
      [attrPlaceholder]="'Enter default text'"
      [inputCss]="'hp-92'"
      [label]="'Default Value'"></app-input-area>
  </form>
</mat-dialog-content>

<mat-dialog-actions class="display-flex justify-content-end grid-gap-16">
  <button
    class="add-custom-field-modal-button"
    mat-stroked-button
    color="warn"
    (click)="cancel()"
    [disabled]="isSaving">
    Cancel
  </button>
  <button
    class="add-custom-field-modal-button"
    mat-raised-button
    color="primary"
    (click)="save()"
    [disabled]="isSaving">
    <div class="display-flex align-items-center grid-gap-8">
      <mat-progress-spinner *ngIf="isSaving" diameter="30" color="primary" mode="indeterminate"></mat-progress-spinner>
      <span>Done</span>
    </div>
  </button>
</mat-dialog-actions>

<ng-template #customValueTemplate let-value="value">
  <ng-container *ngIf="value && getDropdownItemByValue(value) as item">
    <div class="display-flex grid-gap-6 align-items-center">
      <div
        *ngIf="item?.color"
        class="custom-dropdown-color-circle"
        [ngStyle]="{ 'background-color': item.color }"></div>
      <span *ngIf="item?.label">
        <span *ngIf="item?.groupLabel" class="custom-dropdown-group-label">{{ item.groupLabel }}:</span>
        {{ item.label }}
      </span>
    </div>
  </ng-container>
</ng-template>

<ng-template #customListItemTemplate let-item="item">
  <div class="w-100 display-flex grid-gap-6 custom-fade-truncate">
    <div *ngIf="item?.color" class="custom-dropdown-color-circle" [ngStyle]="{ 'background-color': item.color }"></div>
    <div *ngIf="item?.label">{{ item.label }}</div>
  </div>
</ng-template>
